export default __webpack_public_path__ + "static/button-alignment-page-dark-67580a2bb456ac75ec0a92ede325598e.png";